module.exports = __webpack_public_path__ + "img/t3-c13.f4a7becf.png";